"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const ButtonsFactory_1 = require("../../../helpers/ButtonsFactory");
const Translate_1 = require("../Translate");
require("./Button.scss");
const animatedTextTransitionTimer = 150;
class Button extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            isPrimaryButtonClicked: false,
            text: this.props.text,
            isAnimatedButtonFocused: false
        };
    }
    render() {
        const { type, text, title, iconSrc, isAnimated } = this.props;
        if (type === ButtonsFactory_1.ButtonType.Primary) {
            return (React.createElement("button", { className: this.state.isPrimaryButtonClicked && isAnimated ?
                    "btn primary primaryAnimated" : "btn primary", onClick: (e) => {
                    this.onClickHandler(e);
                    if (isAnimated) {
                        this.setState({ isPrimaryButtonClicked: true });
                        // differentiate from isPrimaryButtonClicked state to create transition effect
                        setTimeout(() => this.setState({
                            text: this.props.animatedText || "",
                        }), animatedTextTransitionTimer);
                    }
                }, "data-tid": this.props["data-tid"], onFocus: isAnimated ? this.onAnimatedButtonFocus.bind(this) : null, onBlur: isAnimated ? this.onAnimatedButtonBlur.bind(this) : null },
                this.getImage(iconSrc),
                this.getPrimaryContent(title, this.state.text)));
        }
        else {
            return (React.createElement("div", { className: `btn secondary` },
                this.getImage(iconSrc),
                this.getSecondaryContent(title, text, !!this.props.firstLineAsLink)));
        }
    }
    getPrimaryContent(title, text) {
        return (React.createElement("div", { className: 'text' },
            React.createElement("h3", null,
                React.createElement(Translate_1.Translate, { i18n: title })),
            this.props.isAnimated ?
                React.createElement("p", { "aria-live": this.state.isAnimatedButtonFocused ? "polite" : "off", "aria-atomic": "true", className: "textTransition" },
                    React.createElement(Translate_1.Translate, { i18n: text })) :
                React.createElement("p", null,
                    React.createElement(Translate_1.Translate, { i18n: text }))));
    }
    getSecondaryContent(title, text, secondaryFirstLineAsLink) {
        return (React.createElement("div", { className: "text" }, secondaryFirstLineAsLink ?
            React.createElement("p", null,
                React.createElement("a", { href: "#", onClick: (e) => this.onClickHandler(e), "data-tid": this.props["data-tid"] },
                    React.createElement(Translate_1.Translate, { i18n: title })),
                React.createElement("br", null),
                React.createElement(Translate_1.Translate, { i18n: text }))
            : React.createElement("p", null,
                React.createElement(Translate_1.Translate, { i18n: title }),
                React.createElement("br", null),
                React.createElement("a", { href: "#", onClick: (e) => this.onClickHandler(e), "data-tid": this.props["data-tid"] },
                    React.createElement(Translate_1.Translate, { i18n: text })))));
    }
    onAnimatedButtonFocus() {
        this.setState({ isAnimatedButtonFocused: true });
    }
    onAnimatedButtonBlur() {
        this.setState({ isAnimatedButtonFocused: false });
    }
    getImage(src) {
        if (src) {
            return React.createElement("img", { src: src, className: "img", "aria-hidden": true });
        }
        else {
            return React.createElement("div", { className: "img" });
        }
    }
    onClickHandler(event) {
        event.preventDefault();
        this.props.onClick();
    }
}
exports.Button = Button;
